module.exports = __webpack_public_path__ + "img/icon-speed-9.289d77f7.svg";